import axiosInstance from '../../utils/axios';
import { TransactionStatusResponse } from './interfaces';

export const getTransactionStatus = async (
  externalId: string,
): Promise<TransactionStatusResponse | null> => {
  try {
    const response = await axiosInstance.get<TransactionStatusResponse>(
      `/transactions/status/${externalId}`,
    );

    return response.data;
  } catch (error: any) {
    return null;
  }
};
